'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
}

export const H2: React.FC<TypographyProps> = ({ children, className }) => {
  return (
    <h2
      className={cn(
        // Responsive text size and tracking
        'text-3xl sm:text-4xl md:text-5xl lg:text-[50px] leading-tight md:leading-snug lg:leading-none',
        // Font and alignment
        'font-dmSans font-semibold tracking-tight sm:tracking-[-1px] md:tracking-[-1.5px] lg:tracking-[-2px]',
        'gradient-text',
        className,
      )}
    >
      {children}
    </h2>
  );
};
